import { ImageLoaderProps } from 'next/image';

export function myImageLoader({ src, width }: ImageLoaderProps) {
    return `${src}?w=${width}`;
}
